import { DateUtil } from '@/utils';
import mutations from './gridExmplMutation';
import actions from './gridExmplAction';
import getters from './gridExmplGetter';

const state = {
  cnt: 0,
  gridData: {},
  searchParam: {
    divisionCode: '', // 사업부
    cspCode: '', // CSP
    accoutId: '', // Account
    keyAge: '', // Key Age
    uploadDate: null, // 조회일자
  },
  item: {},
  projectList: [],
  columnHeaderList: [], // 컬럼명
  columnNameList: [], // DB 컬럼과 매핑
};

export default {
  state,
  mutations,
  actions,
  getters,
  DateUtil,
};



// WEBPACK FOOTER //
// ./src/vuex/sample/gridExmpl/gridExmplStore.js